import { render } from "./OperationOrdersForm.vue?vue&type=template&id=a72b6fac"
import script from "./OperationOrdersForm.vue?vue&type=script&lang=js"
export * from "./OperationOrdersForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__